const FLOOD_SLIDER = ({
  min = 0,
  max = 300,
  step = 10,
  name = "flood_level_cm_editable",
  value,
  onChange,
  height = 200,
}) => {
  const range = max - min;
  const marks = [
    min,
    min + range * 0.25,
    min + range * 0.5,
    min + range * 0.75,
    max,
  ];

  return (
    <main className="margin_top margin_bottom">
      <section
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: `${height}px`,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "0.05rem",
            transform: "rotate(-90deg)",
            transformOrigin: "center",
          }}
        >
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            name={name}
            value={value}
            onChange={onChange}
            aria-label="Percentage slider"
            aria-valuetext={`${value} percent`}
            style={{ width: `calc( ${height}px + 25px)` }}
          />

          <div
            style={{
              position: "relative",
              width: `${height}px`,
              // transform: "translateX(5px)",
            }}
          >
            {marks.map((mark, index) => (
              <div
                key={mark}
                style={{
                  position: "absolute",
                  left: `${(index / (marks.length - 1)) * 100}%`,
                  transform: "translateX(-50%)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "19px",
                }}
              >
                <div
                  style={{
                    width: "3px",
                    height: "25px",
                    background: "#000",
                  }}
                ></div>
                <span
                  style={{
                    fontSize: "13px",
                    whiteSpace: "nowrap",
                    transform: "rotate(90deg)",
                  }}
                >
                  {Math.round(mark)} cm
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default FLOOD_SLIDER;
